/**
 * Spec 10.9: what a second finger does to a stroke the first one began.
 * Within 120ms it was the start of a pinch, so the stroke is taken back;
 * later than that the coach meant it, so the stroke so far is kept.
 */
export const SECOND_FINGER_GRACE_MS = 120;

export function secondFingerAction(msSinceStrokeStart: number): 'cancel' | 'keep' {
  return msSinceStrokeStart <= SECOND_FINGER_GRACE_MS ? 'cancel' : 'keep';
}

/**
 * Spec 13.11: whether a finished stroke shows anything, so undo is only ever
 * offered for something on screen. A tap that never moved, a stroke wholly
 * outside the picture, and the eraser over a picture with nothing drawn on
 * it all change nothing and are not kept.
 */
export function strokeShows(s: { moved: boolean; inside: boolean; eraser: boolean; hadDrawing: boolean }): boolean {
  return s.moved && s.inside && (!s.eraser || s.hadDrawing);
}

/**
 * Spec 15.16: a tap on the recorder's video (one finger, under 250ms,
 * never more than 8 from where it came down) shows or hides the timeline.
 * A stroke starts only once the finger is more than 8 away, so a tap never
 * draws and a stroke is never a tap, whatever the tool.
 */
export const TAP_MAX_MS = 250;
export const TAP_SLOP = 8;
export function isTap(ms: number, distance: number): boolean {
  return ms < TAP_MAX_MS && distance <= TAP_SLOP;
}
export function strokeArmed(distance: number): boolean {
  return distance > TAP_SLOP;
}
